import {Component, Input, EventEmitter, Output} from '@angular/core';

import {Notification} from './notification';
import {NotificationsService} from './notifications.service';
import {UIMenuComponent} from 'app/ui/menu/menu.component';

@Component({
    selector: 'notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss']
})
export class NotificationComponent {

    @Input()
    notification: Notification;

    @Output()
    close = new EventEmitter();

    constructor(private _menuComponent: UIMenuComponent,
                private _notificationsService: NotificationsService) {
    }

    onClose() {
        this._processButtonAction();
        this._menuComponent.close();
        this.close.emit();
    }

    private _processButtonAction() {
        const buttonAction = this.notification.buttonAction;
        if (buttonAction.startsWith('http')) {
            // with 'noopener' option open opens new window, not tab
            const newWindow = open(buttonAction, '_blank');
            newWindow.opener = null;
        }
    }
}